import React, { useEffect, useState } from 'react';
import {
  View,
  Text,
  StyleSheet,
  KeyboardAvoidingView,
  Platform,
  ScrollView,
} from 'react-native';
import CancelOrder from '../../portfolio/forms/CancelOrder';
import MergeForm from '../../portfolio/forms/MergeForm';
import RemoveLiquidity from '../../portfolio/forms/RemoveLiquidity';
import SingleOrder from '../../portfolio/forms/SingleOrder';
import AddLiquidity from './AddLiquidity';
import TradeInfoCDABuy from './TradeInfoCDABuy';
import TradeInfoInstant from './TradeInfoInstant';
import TradeStatus from './TradeStatus';
import { useGetProbeData } from './useGetProbeData';
import { useGetProbeDataBuy } from './useGetProbeDataBuy';
import UserSide from './UserSide';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useDispatch, useSelector } from 'react-redux';
import { globalConst } from '../../../utils/globalConstant';
import { globalStyle } from '../../../assets';
import { isMobile } from '../../../utils/commonMethods';
import { useRoute } from '@react-navigation/native';
import { getContestCoinsBalance } from '../../contest/redux/contest.action';
import PowerTrade from "./PowerTrade";

const BuySell = ({
  _eventInfo,
  onTradeClickReloadEventApi,
  invested_amount,
  orderBookSelectedData,
  apiRespnseUiData,
  isPortfolio = false,
  closeSheet,
}) => {
  const [isBuy, setIsBuy] = useState(!isPortfolio);
  const logedIn = useSelector(({ utilReducer }) => utilReducer.isAppLogin);
  const route = useRoute();
  const contestId = route?.params?.contestId;
  const dispatch = useDispatch();
  const onOrderStatusCallback = (
    orderStatus,
    isMergeOrder = false,
    isLiquidityOrder = false,
    removeLiquidity = false,
    isPowerTrade = false
  ) => {
    if (contestId) {
      dispatch(getContestCoinsBalance(contestId));
    }
    if (isPortfolio) {
      onTradeClickReloadEventApi(orderStatus, isMergeOrder, removeLiquidity);
    } else {
      onTradeClickReloadEventApi(orderStatus, isLiquidityOrder, isPowerTrade);
    }
  };
  const onToggleBuySell = param => {
    isBuy !== param && setIsBuy(!isBuy);
  };
  const onDoneClick = () => {
    onTradeClickReloadEventApi('');
    //setApiResponseUiData({ isShow: false, orderData: null });
  };

  const SellBlock = ({ eventDetails, orderStatus }) => {
    const eventData = isPortfolio ? eventDetails.probe : eventDetails;
    const probeData = useGetProbeData(eventData?.id, isPortfolio, eventData);

    const sellEventData = isPortfolio
      ? { ...eventDetails, probe: { ...eventData, ...probeData } }
      : {
        probe: { ...eventDetails, ...probeData },
        isYes: true,
      };

    return (
      // <TradeInfoSell eventDetails={sellEventData} orderStatus={orderStatus} />
      <SingleOrder
        eventInfo={_eventInfo?.probe}
        setIsSellForm={onToggleBuySell}
        isSellForm={!isBuy}
        orderStatus={orderStatus}
        eventDetails={sellEventData}
        isIm={!eventData?.is_price_editable}
        closeSheet={closeSheet}
      />
    );
  };

  const BuyBlock = ({ eventDetails, orderStatus }) => {
    const eventData = isPortfolio ? eventDetails.probe : eventDetails;
    let probeData = useGetProbeDataBuy(isPortfolio, eventData?.id, eventData);
    invested_amount = invested_amount || eventData?.total_investment;
    /* orderBookSelectedData = orderBookSelectedData
      ? orderBookSelectedData
      : { callvalue: "Y" };*/
    return !eventData?.is_price_editable ? (
      <SingleOrder
        eventInfo={_eventInfo}
        buySell={onToggleBuySell}
        eventDetails={{
          ...eventData,
          ...probeData,
          ...orderBookSelectedData,
        }}
        orderStatus={orderStatus}
        orderBookSelectedData={orderBookSelectedData}
        // onBottomSheetOpen={onBottomSheetOpen}
        invested_amount={invested_amount}
        isIm={true}
        isSellForm={!isBuy}
        setIsSellForm={onToggleBuySell}
        closeSheet={closeSheet}
      />
    ) : (
      <SingleOrder
        eventInfo={_eventInfo}
        buySell={onToggleBuySell}
        eventDetails={{
          ...eventData,
          ...probeData,
          ...orderBookSelectedData,
        }}
        orderStatus={orderStatus}
        orderBookSelectedData={orderBookSelectedData}
        invested_amount={invested_amount}
        isIm={false}
        isSellForm={!isBuy}
        setIsSellForm={onToggleBuySell}
        closeSheet={closeSheet}
      />
    );
  };

  const TradeInfoSellCancel = (
    <>
      {_eventInfo?.isCancel ? (
        <CancelOrder
          eventDetails={_eventInfo}
          orderStatus={onOrderStatusCallback}
          closeSheet={closeSheet}
        />
      ) : _eventInfo?.isRemoveShare ? (
        <RemoveLiquidity
          eventDetails={_eventInfo}
          orderStatus={onOrderStatusCallback}
          closeSheet={closeSheet}
        />
      ) : _eventInfo?.isMerge ? (
        <MergeForm
          eventDetails={_eventInfo}
          orderStatus={onOrderStatusCallback}
          closeSheet={closeSheet}
        />
      ) : (
        <>
          <SellBlock
            eventDetails={_eventInfo}
            orderStatus={onOrderStatusCallback}
          />
        </>
      )}
    </>
  );

  const TradeInfoEventForms = (
    <View>
      {logedIn ? (
        orderBookSelectedData?.isShowLiquidity ? (
          <AddLiquidity
            eventDetails={_eventInfo}
            orderStatus={onOrderStatusCallback}
            closeSheet={closeSheet}
          //onBottomSheetClose={onBottomSheetClose}
          />
        ) : (
          orderBookSelectedData?.isPowerTrade ? (
            <PowerTrade
              eventDetails={_eventInfo}
              orderStatus={onOrderStatusCallback}
              closeSheet={closeSheet}
            //onBottomSheetClose={onBottomSheetClose}
            />
          ) : (
            // (orderBookSelectedData || !isMobile()) && (
            <>
              <BuyBlock
                eventDetails={_eventInfo}
                orderStatus={onOrderStatusCallback}
              />
            </>
            // )
          )
        )
      ) : (
        <UserSide orderStatus={onOrderStatusCallback} _eventInfo={_eventInfo} />
      )}
    </View>
  );

  return (
    <ScrollView
      contentContainerStyle={!isMobile() ? globalStyle.desktopRightBox : {}}
      keyboardShouldPersistTaps={'handled'}
      scrollEnabled={false}>
      {!apiRespnseUiData?.isShow ? (
        !isBuy ? (
          <>{TradeInfoSellCancel}</>
        ) : (
          <>{TradeInfoEventForms}</>
        )
      ) : (
        <TradeStatus
          onDoneClick={() => {
            setTimeout(() => {
              onDoneClick();
            }, globalConst?.buttonTimer);
          }}
          apiRespnseUiData={apiRespnseUiData}
        />
      )}
      {/*<TradeStatus />*/}
    </ScrollView>
  );
};

export default React.memo(BuySell);
